<!-- eslint-disable -->
<template>

    <div>
        <!--begin::Notice-->
        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/Tools/Compass.svg" />
        </span>
            </div>
            <div class="alert-text">
                Создайте категорию товаров
            </div>
        </b-alert>
        <!--end::Notice-->

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Добавить категорию</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <div v-else >
                            <label>Изображение категории</label>

                            <div class="mb-3 mt-3">
                                <b-img v-if="image" :src="$urlBackEnd(image)" fluid alt="Responsive image"></b-img>
                            </div>

                            <button @click="deleteImage" v-if="image" class="btn btn-danger btn-sm mb-4">Удалить изображение</button>

                            <input v-model="image" type="hidden">

                            <vue-dropzone ref="myVueDropzone"
                                          id="dropzone"
                                          :options="dropzoneOptions"
                                          :useCustomSlot=true
                                          v-on:vdropzone-success="successDrop"
                                          v-on:vdropzone-max-files-exceeded="maxDrop"
                            >
                                <div class="dropzone-custom-content">
                                    <b class="dropzone-custom-title">Выберите файл</b>
                                    <div class="subtitle">...или перетащите его сюда</div>
                                </div>
                            </vue-dropzone>



                            <label class="mt-5">Иконка категории</label>

                            <div class="icon mt-4">
                                <img v-if="icon" :src="$urlBackEnd(icon)" alt="icon">
                            </div>


                            <div class="icon-category">
                            <vue-dropzone ref="myVueDropzoneIcon"
                                          id="dropzoneIcon"
                                          :options="dropzoneOptionsIcon"
                                          :useCustomSlot=true
                                          v-on:vdropzone-success="successDropIcon"
                                          v-on:vdropzone-max-files-exceeded="maxDrop"
                            >
                                <div class="dropzone-custom-content">
                                    <b class="dropzone-custom-title">Выберите иконку</b>
                                </div>
                            </vue-dropzone>
                            </div>


                            <b-form-group class="mt-5"
                                          description="Введите заголовок категории"
                                          label="Заголовок:"
                            >
                                <b-form-input
                                        v-model.trim="name"
                                        :class="{'is-invalid': errors.name}"
                                        required
                                ></b-form-input>
                                <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                            </b-form-group>


                            <b-form-group class="mt-0" description="Введите url товара или нажмите кнопку *Сформировать" label="url товара:">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button @click="getCode" v-b-tooltip.hover title="Сформировать url адрес страницы категории на основе заголовка" ref="get_category_url" class="btn btn-primary" type="button">Сформировать</button>
                                    </div>
                                    <b-form-input v-model.trim="code" :class="{'is-invalid': errors.code}"></b-form-input>
                                    <div v-if="errors.code" class="invalid-feedback">{{errors.code[0]}}</div>
                                </div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          description="Введите описание категории"
                                          label="Описание:"

                            >
                                <b-form-textarea
                                        id="description"
                                        v-model.trim="description"
                                        :class="{'is-invalid': errors.description}"
                                ></b-form-textarea>
                                <div v-if="errors.description" class="invalid-feedback">{{errors.description[0]}}</div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          description="Назначьте родительский элемент для создания иерархии"
                                          label="Корневая категория:"
                            >
                                <b-form-select v-model="subcategory" class="mb-3">
                                    <option :value="null">Нет</option>
                                    <template v-for="(category, i) in categories" >
                                    <option v-bind:key="i" :value="category.id">{{category.name}}</option>
                                    </template>
                                </b-form-select>
                            </b-form-group>


                            <div v-if="subSubcategory && filter.length > 0" class="my-5">
                                <b-button block v-b-toggle.filters variant="primary">Фильтры</b-button>
                                <b-collapse id="filters" class="mt-5">

                                    <div  class="table-responsive mt-3">
                                        <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                            <thead>
                                            <tr class="text-left">
                                                <th class="pl-0" style="width: 40px;">
                                                    <label class="checkbox checkbox-lg checkbox-inline mr-2">
                                                        <input type="checkbox"
                                                               v-model="selectAll"
                                                        />
                                                        <span></span>
                                                    </label>
                                                </th>
                                                <th class="pr-0 text-left">Атрибуты</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template v-for="(attribute, i) in filter">
                                                <tr v-bind:key="i">
                                                    <td class="pl-0 py-6">
                                                        <label class="checkbox checkbox-lg checkbox-inline">
                                                            <input type="checkbox"
                                                                   v-model="filters"
                                                                   :value="attribute"
                                                            />
                                                            <span></span>
                                                        </label>
                                                    </td>
                                                    <td class="pl-0 text-left">
                                                        <b>{{attribute.name}}</b>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-collapse>
                            </div>

                            <b-button @click="addCategory" ref="add_category" type="submit" variant="primary">Создать</b-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>



    </div>

</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_SELECT} from "@/core/services/store/categories.module";
    import {ADD_CATEGORY, GET_NEW_CATEGORY} from "../../../core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {GET_TRANSLATE} from "../../../core/services/store/products.module";
    export default {
        name: "AddCategory",
        components: {
            vueDropzone: vue2Dropzone
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Категории", route: "/categories" },
                { title: "Добавить категорию" }
            ]);
            this.$store.dispatch(GET_SELECT);
            this.$store.dispatch(GET_NEW_CATEGORY);
        },

        computed: {
            ...mapGetters({
                categories: 'getSelectCategory',
                errors: 'errorsCategory',
                filter: 'gettersFilters',
            }),

            selectAll: {
                get: function () {
                    return this.filter ? this.filters.length === this.filter.length : false;
                },
                set: function (value) {
                    const selected = [];

                    if (value) {
                        this.filter.forEach(function (attribute) {
                            selected.push(attribute);
                        });
                    }

                    this.filters = selected;
                }
            }

        },

        data() {
            return {
                name:'',
                code:'',
                description:'',
                image: '',
                icon: '',
                subcategory: null,
                subSubcategory: null,
                filters: [],
                load: false,

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/categories/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

                dropzoneOptionsIcon: {
                    url: this.$urlBackEnd('/api/v1/categories/icon'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 5,
                    maxFiles:1,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                }



            }
        },

        methods:{
            addCategory(){
                const submitButton = this.$refs["add_category"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const category = {
                    name: this.name,
                    code: this.code,
                    description: this.description,
                    image: this.image,
                    icon: this.icon,
                    subcategory: this.subcategory,
                    subSubcategory: this.subSubcategory,
                    filters: this.filters,
                };

                this.$store.dispatch(ADD_CATEGORY, category)
                    .then(() => {
                        this.showAlert('Категория успешно добавлена', 'success');
                        this.$router.push({ name: "Categories" })

                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            async getCode(){

                const submitButtonUrl = this.$refs["get_category_url"];
                submitButtonUrl.classList.add("spinner", "spinner-light", "spinner-right");

                try {
                    const data = await this.$store.dispatch(GET_TRANSLATE, {title: this.name});
                    this.code = data.code;
                    this.showAlert('URL адрес успешно сформирован ', 'success', 'toast');
                } catch (response) {
                    if (response.status === 422){
                        this.showAlert('Введите название категории', 'danger', 'toast');
                    } else {
                        this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    }
                } finally {
                    submitButtonUrl.classList.remove("spinner", "spinner-light", "spinner-right")
                }
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.image = response.original;
            },

            successDropIcon (file, response) {
                this.$refs.myVueDropzoneIcon.removeAllFiles();
                this.icon = response.original;
            },



            maxDrop (){
                console.log('Не более одного файла')
            },

            deleteImage(){
                this.image = null;
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },
        }
    }
</script>

<style>

    .icon-category .dropzone{

        min-height: auto;
        padding: 5px 5px;
        background: #f0f0f0;
        border: none;
    }

    .icon-category{
        margin: 10px 0 10px 0;
        height: 50px;
        width: 100px;

    }

    .icon-category .dropzone .dz-message{
        margin: 5px;
    }



</style>